'use strict';

/**
 * @classname Speakers
 * @classdesc 登壇者プロフィールの開閉
 */
export default class Speakers {
	/**
	 * @constructor
	 * @param {jQuery} $e - .section--speakers
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$section = $e;

		this._$section.find('.btn--detail-toggle').on('click', (e) => this.onClickToggle(e));
		this._$section.find('.btn--detail-close').on('click', (e) => this.onClickClose(e));
		$('.anchor--kv-seminar').on('click', (e) => this.onClickSeminarLink(e));
	};

	onClickSeminarLink(e) {
		if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
		const section = this._$section.get(0);
		if (!section || e.currentTarget.hash !== `#${section.id}`) return;
		e.preventDefault();
		const headerHeight = Array.from(document.querySelectorAll('#header-sp, #header-sp .header__cta-bar, #header-fixed'))
			.reduce((height, header) => height + header.offsetHeight, 0);
		section.style.scrollMarginTop = `${headerHeight + 16}px`;
		section.focus({ preventScroll: true });
		section.scrollIntoView({
			behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
			block: 'start'
		});
		if (window.location.hash !== e.currentTarget.hash) {
			window.history.pushState(null, '', e.currentTarget.hash);
		}
	}

	/**
	 * 詳細を開く
	 *
	 * @memberof Speakers
	 * @return undefined
	 */
	onClickToggle(e) {
		const $card = $(e.currentTarget).closest('.card--speakers');
		$card.addClass('is-open');
		this.updateProfileState();
		const detail = $card.find('.block--speaker-detail').get(0);
		if (detail) {
			// SPのCTAは絶対配置のため、ヘッダー本体とは別に高さを加算する。
			const headerHeight = Array.from(document.querySelectorAll('#header-sp, #header-sp .header__cta-bar, #header-fixed'))
				.reduce((height, header) => height + header.offsetHeight, 0);
			// PCは画面の約1/4の位置へ。低い画面では枠の下端も収まる範囲に抑える。
			const profileTop = window.matchMedia('(min-width: 768px)').matches
				? Math.max(headerHeight + 16, Math.min(window.innerHeight * 0.25, window.innerHeight - detail.offsetHeight - 24))
				: headerHeight + 16;
			detail.style.scrollMarginTop = `${profileTop}px`;
			detail.scrollTop = 0;
			detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	/**
	 * 詳細を閉じる
	 *
	 * @memberof Speakers
	 * @return undefined
	 */
	onClickClose(e) {
		$(e.currentTarget).closest('.card--speakers').removeClass('is-open');
		this.updateProfileState();
	}

	updateProfileState() {
		this._$section.toggleClass('has-open-profile', this._$section.find('.card--speakers.is-open').length > 0);
	}
};
